module.exports = __webpack_public_path__ + "static/media/MasterBath2.a7f69981.jpg";